import {useQuery} from "@tanstack/react-query";

import {eatClubClient} from "@globals/config/apiClient";
import {DateString} from "@globals/types/utilityTypes";

import {SocialProofType} from "./interfaces";

export type SocialProofInfoParams = {
  key?: string;
  menu_date?: DateString;
  location_id?: number;
};

const typesInAscendingOrderOfPrecedence: SocialProofType[] = [
  SocialProofType.HighestRating,
  SocialProofType.MostFavorite,
  SocialProofType.MostPopular,
];

export function getSocialProofInfo(
  params?: SocialProofInfoParams
): Promise<{[key: number]: SocialProofType}> {
  return eatClubClient
    .get("/social_proof/menu_social_info/", {
      params,
    })
    .then((response) => response.data)
    .then((response) => {
      const items: {[key: number]: SocialProofType} = {};

      typesInAscendingOrderOfPrecedence.forEach(
        (proofType: SocialProofType) => {
          const itemId = response[proofType];

          if (itemId) {
            items[itemId] = proofType;
          }
        }
      );
      return items;
    });
}

export function useSocialProof(
  inviteKey?: string,
  selectedDate?: DateString,
  selectedLocationId?: number
): {
  socialProofs: {[key: number]: SocialProofType} | undefined;
} {
  const requestParams: SocialProofInfoParams = {
    key: inviteKey,
    menu_date: selectedDate,
    location_id: selectedLocationId,
  };

  const {data} = useQuery<{[key: number]: SocialProofType}>({
    queryKey: ["socialProof", selectedDate, selectedLocationId],
    queryFn: () => getSocialProofInfo(requestParams),
    enabled: Boolean(selectedDate ?? inviteKey),
  });

  return {
    socialProofs: data,
  };
}
